// extracted by mini-css-extract-plugin
export default {"default":"button-back_default__UTiaG","static":"button-back_static__nF4RO","phone-form":"button-back_phone-form__c2xqh"};